import { createReducer } from "@reduxjs/toolkit";
import { studentRetrievePendingSurveys } from "./retrieve-pending-surveys";
import type { PendingSurveyVM } from "@shared-kernel/application/ports/student/student-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<PendingSurveyVM[]> = {
  fetching: "idle",
  data: [],
};

export const pendingSurveysRetrievalReducer = createReducer<RetrievalState<PendingSurveyVM[]>>(initialState, builder => {
  builder.addCase(studentRetrievePendingSurveys.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(studentRetrievePendingSurveys.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(studentRetrievePendingSurveys.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
